module.exports = __webpack_public_path__ + "img/facebook.874e2ae7.svg";